export default "__VITE_ASSET__C24myH6V__"